import React, { useEffect } from "react";
import { ThemeProvider } from "styled-components";
import { useApp } from "./contexts/AppContext";
import themeDefault from "theme/default";
import PropTypes from "prop-types";

const WhitelabelThemeProvider = ({ children }) => {
  const { whitelabel } = useApp();

  useEffect(() => {
    const name =
      typeof whitelabel?.assets?.name === "string"
        ? whitelabel.assets.name.trim()
        : "";
    if (name) {
      document.title = name;
    }

    const faviconUrl =
      typeof whitelabel?.assets?.favicon_url === "string"
        ? whitelabel.assets.favicon_url.trim()
        : "";

    const existing =
      document.querySelector('link[rel="icon"]') ||
      document.querySelector('link[rel="shortcut icon"]') ||
      document.querySelector('link[rel~="icon"]');
    const link =
      existing || Object.assign(document.createElement("link"), { rel: "icon" });

    link.href = faviconUrl || "data:,";

    if (!existing) document.head.appendChild(link);
  }, [whitelabel]);

  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") return;

    const gtmFromAnalytics =
      typeof whitelabel?.analytics?.gtm_container_id === "string"
        ? whitelabel.analytics.gtm_container_id.trim()
        : "";

    const gtmId = gtmFromAnalytics;

    const headScriptId = "gtm-dynamic-loader";
    const bodyNoscriptId = "gtm-dynamic-noscript";

    const existingScript = document.getElementById(headScriptId);
    const existingNoscript = document.getElementById(bodyNoscriptId);

    if (!gtmId) {
      if (existingScript?.parentNode) existingScript.parentNode.removeChild(existingScript);
      if (existingNoscript?.parentNode) existingNoscript.parentNode.removeChild(existingNoscript);
      return;
    }

    // Avoid re-injecting if the same container is already active.
    if (existingScript?.dataset?.gtmId === gtmId) return;

    if (existingScript?.parentNode) existingScript.parentNode.removeChild(existingScript);
    if (existingNoscript?.parentNode) existingNoscript.parentNode.removeChild(existingNoscript);

    // Google Tag Manager (script)
    const script = document.createElement("script");
    script.id = headScriptId;
    script.dataset.gtmId = gtmId;
    script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`;
    document.head.appendChild(script);

    // Google Tag Manager (noscript)
    const noscript = document.createElement("noscript");
    noscript.id = bodyNoscriptId;
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(gtmId)}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);

    if (document.body.firstChild) {
      document.body.insertBefore(noscript, document.body.firstChild);
    } else {
      document.body.appendChild(noscript);
    }
  }, [whitelabel]);

  const theme = {
    ...themeDefault,
    whitelabel,
  };

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

WhitelabelThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default WhitelabelThemeProvider;
